export const VIP_LEVELS = [
  "NEW",
  "NORMAL",
  "COPPER",
  "SILVER",
  "GOLD",
  "PLATINUM",
  "EMERALD",
  "SAPPHIRE",
  "DIAMOND",
];
